<template>
    <div v-show="visible">
        <el-dialog title="修改余额" :close-on-click-modal="false" :visible.sync="visible" 
            v-loading="loading"
            element-loading-background = "rgba(255, 255,255,0.7)"
            element-loading-text = "保存中..."
            :before-close="dialogClose" width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="140px">
                <el-form-item  prop="days" :label="form.vacationNameLabel">
                    <el-select v-model="form.operateType" placeholder="请选择" style="width:130px;">
                        <el-option
                            v-for="item in operateTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input v-model="form.days" max="100"  min="1" type="number" oninput ="value=value.replace(/[-]/g,'');" style="width:115px;"></el-input>&nbsp;天
                </el-form-item>

                <el-form-item  prop="reason" label="理由：">
                    <el-input
                            type="textarea"
                            placeholder=""
                            v-model="form.reason"
                            maxlength="200"
                            show-word-limit>
                        </el-input>
                </el-form-item>
                 
            </el-form>
            <div style="color:red;font-size:12px;">注：{{form.remark}}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 

    export default {
        data(){
            return{
                loading:false,
                visible: false, 
                form:{
                    id:"",
                    vacationNameLabel:"",
                    operateType:1,
                    days:1,
                    remark:"",
                    reason:""
                },
                operateTypes:[{
                    value: 1,
                    label: '增加'
                }, {
                    value: 2,
                    label: '减少'
                }],
                rules: {
                    days: [
                        { required: true, message: '天数不能为空', trigger: 'blur' }
                    ],
                    reason: [
                        { required: true, message: '理由不能为空', trigger: 'blur' }
                    ]
                },
            }
        },
        created:function () {
        },
        components: {
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id = data.id;
                this.form.vacationNameLabel = "修改"+data.vacationName+"：";
                this.form.days = 1;
                this.form.operateType = 1;
                this.form.remark = data.remark;
                // console.log(JSON.stringify(res.data));
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){

                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.staffVacationSurplusUpdateUrl;
                        
                        let data = {};
                        if(this.form.operateType == 1){ // 增加
                            data = {
                                id:this.form.id,
                                addDays:this.form.days,
                                reason:this.form.reason
                            };
                        }else if(this.form.operateType == 2){ // 减少
                            data = {
                                id:this.form.id,
                                minusDays:this.form.days,
                                reason:this.form.reason
                            };
                        }

                        // console.log(JSON.stringify(data));
                        // return;
                        this.visible=true;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/vacation/vacationSurplus/Update.vue